import { motion } from "framer-motion";

export function SectionLabel({ children, dark = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4 }}
      className="oh-label-pill"
      style={dark ? undefined : undefined}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, dark = false, align = "left", className = "" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  const titleColor = dark ? "text-white" : "text-[#1F1F1F]";
  const subColor = dark ? "text-white/70" : "text-neutral-600";
  return (
    <div className={`flex flex-col gap-6 ${alignCls} ${className}`}>
      {eyebrow ? <SectionLabel dark={dark}>{eyebrow}</SectionLabel> : null}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5 }}
        className={`text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tight ${titleColor} max-w-4xl leading-[1.05]`}
      >
        {title}
      </motion.h2>
      {sub ? (
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className={`text-lg lg:text-xl ${subColor} max-w-2xl leading-relaxed`}
        >
          {sub}
        </motion.p>
      ) : null}
    </div>
  );
}

export default function Section({ id, children, className = "", bg = "white" }) {
  const bgCls =
    bg === "ink" ? "bg-[#1F1F1F] text-white" :
    bg === "soft" ? "bg-[#F7F8F5] text-[#1F1F1F]" :
    bg === "lime" ? "bg-[#99CC00] text-[#1F1F1F]" :
    "bg-white text-[#1F1F1F]";
  return (
    <section id={id} data-testid={id ? `section-${id}` : undefined} className={`${bgCls} ${className} relative`}>
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-20 lg:py-28">
        {children}
      </div>
    </section>
  );
}
